import React, { useEffect } from "react";
import "./Calculator.css";
import { useCalculator } from "./hooks/useCalculator";
import CalculatorDisplay from "./components/CalculatorDisplay";
import CalculatorButtons from "./components/CalculatorButtons";
import HistoryPanel from "./components/HistoryPanel";
import MemoryPanel from "./components/MemoryPanel";
import { PageTitle } from "src/shared/PageTitle";
import { pageTitle } from "src/shared/utils/brand";

const Calculator: React.FC = () => {
  const {
    input, history, memory,
    handleButtonClick, handleDelete, handleClear, handleCalculate,
    handleMemorySave, handleMemoryClear, handleMemoryRecall, handleMemoryAdd,
    handleMemorySubtract, setHistory,
  } = useCalculator();
  
useEffect(() => {
      document.title = pageTitle("Salon › Calculator");
    }, []);

  return (
    <div>
        <div className="calculator-wrapper">
          <PageTitle title="- Calculator" />
          <div className="calculator-container">
            <div className="calculator">
              <CalculatorDisplay value={input} />
              <CalculatorButtons
                onButtonClick={handleButtonClick}
                onClear={handleClear}
                onDelete={handleDelete}
                onCalculate={handleCalculate}
                onMemorySave={handleMemorySave}
                onMemoryRecall={handleMemoryRecall}
                onMemoryAdd={handleMemoryAdd}
                onMemorySubtract={handleMemorySubtract}
              />
            </div>
            <div className="history-memory">
              <HistoryPanel history={history} onClear={() => setHistory([])} />
            </div>
            <div className="memory">
              <MemoryPanel memory={memory} onClear={handleMemoryClear} />
            </div>
          </div>
        </div>
      </div>
    // </div>
  );
};
export default Calculator;
